import { ActivateAccount } from 'components/EmailActions/ActivateAccount';
import { ResetPassword } from 'components/EmailActions/ResetPassword';
import Loader from 'components/Loader';
import React, { Fragment, useEffect, useState } from 'react';

import PageHelmet from 'components/common/Helmet';
import Footer from 'components/footer/Footer';
import Header from 'components/header/Header';
import { Title } from 'components/title/Title';
import queryString from 'query-string';
import { useLocation } from 'react-router';


export const EmailActions = (props) => {
	const { firebase, authUser } = props

	const location = useLocation()

	const queries = queryString.parse(location.search);
	const { mode, oobCode } = queries;

	const [title, setTitle] = useState('Account Action')

	useEffect(() => {
		if (mode === 'verifyEmail') {
			setTitle('Account activation')
		} else {
			setTitle('Password Reset')
		}
	}, [mode])


	return mode ? (
		<Fragment>
			<PageHelmet pageTitle={title} />

			<Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

			<Title title={title} />

			<div className="contact-form--1 pt--50 pb--50">
				<div className="container">
					<div className="row row--35 align-items-center justify-content-center">
						<div className="col-lg-6 order-2">
							{mode === 'verifyEmail'
								? (<ActivateAccount firebase={firebase} actionCode={oobCode} authUser={authUser} /> )
								: (<ResetPassword firebase={firebase} actionCode={oobCode} />)
							}
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</Fragment>
	) : <Loader />
}
